import { configureStore } from "@reduxjs/toolkit";
import loadingReducer from "./reducers/loadingReducer";

const store = configureStore({
  reducer: {
    loading: loadingReducer,
  },
  // You can add middleware here if needed, but thunk is included by default
  // middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: false,
  // devTools: process.env.NODE_ENV !== 'production', // enabled by default
});

export default store;
